import Moment from 'moment';
import React from 'react';
import css from './CarHistory.scss';

export interface HistoryItem {
    name: string;
    date: string | Date;
    plafondUsedAmount: number;
}
interface CarHistoryProps {
    items: HistoryItem[] | null | undefined | false | '';
}
type CarHistoryProperties =
    CarHistoryProps;

const CarHistory: React.FC<CarHistoryProperties> = (Props) => {
    if (!Props || !Props.items) {
        return null;
    }
    const sortedItems = Props.items.sort((a, b) => a.date < b.date ? -1 : a.date > b.date ? 1 : 0);

    if (!sortedItems || sortedItems.length === 0) {
        return <p>Sem dados.</p>;
    }
    return (
        <React.Fragment>
            {
                sortedItems.map((item: HistoryItem, idx: any) => {
                    return (
                        <div className={css.mainContent} key={`chist${idx}`}>
                            <div className={css.badge}>
                                <h3>{Moment(item.date).format('DD/MM/YYYY')}</h3>
                            </div>
                            <div className={css.row}>
                                <div className={css.inputBreak}>
                                    <h4>{item.name}</h4>
                                </div>
                                {item.plafondUsedAmount > 0 && <div className={css.inputBreak}>
                                    <h4>{`Valor desconto: ${item.plafondUsedAmount} EUR`}</h4>
                                </div>}
                            </div>
                        </div>
                    );
                })
            }
        </React.Fragment>
    );
};

export default CarHistory;
